import { Space } from "~/lib/types";
import { TicketSettings } from "~/pages/tickets/components/TicketSettings";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

type Props = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

export const OrganizationSettingsTickets = ({ space, scope }: Props) => {
  return <TicketSettings space={space} scope={scope} />;
};
